module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/6-d0e99ab70bffafb829c305aa2e3df5c6.svg";